import {
  PostMessage,
  PostMessageListenerMessages,
  IframeService as IframeServiceBase,
} from '@pascal/iframe-service';
import { setHttpClientInterceptors } from '../http/httpClient';
import { applicationStore } from '../../store/applicationStore';
import { userInfoStore } from '../../store/userInfoStore';
import { autoBetStore } from '../../store/autoBetStore';
import { liveUpdateStore } from '../../store/liveUpdateStore';
import { HISTORY_COLUMN_ID } from '../../core/constants/liveBetsContants';
import { popupStore } from '../../store/popupStore';
import { PopupTypes } from '../../core/constants/popupTypes';
import { platformMessageStore } from '../../store/platformMessageStore';
import { connectionLostHandler } from '../../core/helpers/connectionLostHandler';
import { userSettingsStore } from '../../store/userSettingsStore';

class IframeService extends IframeServiceBase {
  // sendParentMessage(message, transfer, targetOrigin = '*') {
  //   window.parent.postMessage(message, targetOrigin, transfer);
  // }

  // sendTopMessage(message, transfer, targetOrigin = '*') {
  //   window.top.postMessage(message, targetOrigin, transfer);
  // }

  // exitGame() {
  //   this.sendParentMessage(PostMessage.ExitGame, {});
  // }

  // openTab(tab) {
  //   this.sendTopMessage({ action: 'openSlider', tab });
  // }

  // openDeposit() {
  //   this.sendParentMessage({ name: PostMessage.OpenDeposit });
  // }
  //
  // openLogin() {
  //   this.sendParentMessage(PostMessage.PgLoginCheck);
  // }

  // reloadFrame() {
  //   this.sendParentMessage(PostMessage.PgReload);
  // }

  // logout() {
  //   this.sendParentMessage({ name: PostMessage.logout });
  // }

  sendLoadedState() {
    const { betAmount } = userInfoStore;
    this.sendParentMessage({ name: PostMessage.GameLoaded, payload: { stakeAmount: betAmount } });
  }

  // sendGetAuthInfo() {
  //   this.sendParentMessage(PostMessage.PgGetAuthInfo);
  // }

  // sendPgLogin() {
  //   this.sendParentMessage(PostMessage.PgLoginCheck);
  // }

  // redirectLogin() {
  //   this.sendParentMessage(PostMessage.PgRedirectLogin);
  // }
  //
  // redirectHome() {
  //   this.sendParentMessage(PostMessage.PgRedirectHome);
  // }
  //
  // redirect(type = false) {
  //   type ? this.redirectHome() : this.redirectLogin();
  // }

  // /**
  //  * @deprecated please use redirect
  //  */
  // redirection(type) {
  //   this.redirect(type);
  // }

  // isInIframe() {
  //   try {
  //     return window.self !== window.top;
  //   } catch (e) {
  //     return true;
  //   }
  // }

  sendOpenPlayerStat(betId, gameId) {
    this.sendParentMessage({ name: PostMessage.pgOpenPlayerStat, betId, gameId });
  }

  setPostMessageListener(messageParams) {
    if (!this.isInIframe()) {
      applicationStore.setIsAuthDataReceived(true);
    } else {
      window.addEventListener('message', (message) => {
        if (message.data.isCrypto) {
          userInfoStore.setCurrencyFromToken(message.data.currencyCode);
        }
        if (message.data.needReconnect) {
          autoBetStore.resetAutoBetState();
          userInfoStore.setNeedChangeCurrency(true);
          applicationStore.setAccessToken(message.data.accessToken);
          return;
        }

        if (message.data && message.data.name === PostMessageListenerMessages.AuthInfoUpdate) {
          const { accessToken, isAuthenticated } = message.data;
          applicationStore.setIsAuthenticated(isAuthenticated);
          applicationStore.setAccessToken(accessToken);
          applicationStore.setIsAuthDataReceived(true);
          setHttpClientInterceptors();
        }
        if (message.data && message.data.name === PostMessageListenerMessages.UpdateSettings) {
          const { sound } = message.data.payload;
          userSettingsStore.setIsMusicOnAndIsSoundOn(!sound, true);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.OpenerIcons) {
          applicationStore.setIconsInfo(message.data.icons);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.UpdateBalance) {
          userInfoStore.getBalance();
        }
        if (message.data && message.data.name === PostMessageListenerMessages.OpenHistory) {
          liveUpdateStore.setSelectedColumn(HISTORY_COLUMN_ID);
        }
        if (message.data && message.data.name === PostMessageListenerMessages.StopAutoSpins) {
          autoBetStore.resetAutoBetState();
        }
        if (
          message.data &&
          (message.data.name === PostMessageListenerMessages.OpenGameHelp ||
            message.data.name === PostMessageListenerMessages.OpenPayTable)
        ) {
          const { popupName, open, close } = popupStore;
          popupName === PopupTypes.GameRules ? close() : open({ name: PopupTypes.GameRules });
        }

        if (message.data && message.data.name === PostMessageListenerMessages.PauseGame) {
          // const { sound, fastPlay } = message.data.payload;
          // userSettingsStore.setIsSoundAndMusicMute(sound);
          popupStore.close();
          const {
            // eslint-disable-next-line no-shadow
            mainGameConnection,
            // eslint-disable-next-line global-require
          } = require('../../core/mainGameConnection/mainGameConnection');
          !platformMessageStore.isGamePaused &&
            connectionLostHandler(mainGameConnection, true, true, false);
          platformMessageStore.setIsGamePaused(true);
        }

        if (message.data && message.data.name === PostMessageListenerMessages.ResumeGame) {
          const {
            // eslint-disable-next-line no-shadow
            mainGameConnection,
            // eslint-disable-next-line global-require
          } = require('../../core/mainGameConnection/mainGameConnection');
          platformMessageStore.isGamePaused &&
            connectionLostHandler(mainGameConnection, true, true);
          platformMessageStore.setIsGamePaused(false);
        }

        if (messageParams && messageParams.length) {
          messageParams.forEach(({ name, callback }) => {
            if (message.data && message.data.name === name) {
              callback(message.data);
            }
          });
        }
      });
    }
  }
}

const iframeService = new IframeService();

export { iframeService, IframeService as BaseIframeService };
